export const AddVehicleSteps = {
  VEHICLE_REGISTRATION: 'VEHICLE_REGISTRATION',
  VEHICLE_DETAILS: 'VEHICLE_DETAILS',
  SPECIFICATION: 'SPECIFICATION',
  DESCRIPTION: 'DESCRIPTION',
  PHOTOS: 'PHOTOS',
  VIDEOS: 'VIDEOS',
  TYRES: 'TYRES',
  SERVICE_HISTORY: 'SERVICE_HISTORY',
  CONDITION_INSPECTION: 'CONDITION_INSPECTION',
  LAUNCH_VEHICLE: 'LAUNCH_VEHICLE',
};

export const AddVehicleStepsName = {
  VEHICLE_REGISTRATION: 'VEHICLE REGISTRATION',
  VEHICLE_DETAILS: 'VEHICLE DETAILS',
  SPECIFICATION: 'SPECIFICATION',
  DESCRIPTION: 'DESCRIPTION',
  PHOTOS: 'PHOTOS',
  VIDEOS: 'VIDEOS',
  TYRES: 'TYRES',
  SERVICE_HISTORY: 'SERVICE HISTORY',
  LAUNCH_VEHICLE: 'LAUNCH VEHICLE',
};

export const AddVehicleNavMapping = {
  [AddVehicleSteps.VEHICLE_REGISTRATION]: [1, 2],
  [AddVehicleSteps.VEHICLE_DETAILS]: [3],
  [AddVehicleSteps.PHOTOS]: [4, 5],
  [AddVehicleSteps.VIDEOS]: [6],
  [AddVehicleSteps.TYRES]: [7],
  [AddVehicleSteps.SERVICE_HISTORY]: [8],
  [AddVehicleSteps.SPECIFICATION]: [9],
  [AddVehicleSteps.DESCRIPTION]: [10],
  [AddVehicleSteps.LAUNCH_VEHICLE]: [11],
};

export const AddVehicleStepsMapping = {
  [AddVehicleSteps.VEHICLE_REGISTRATION]: 1,
  [AddVehicleSteps.VEHICLE_DETAILS]: 3,
  [AddVehicleSteps.PHOTOS]: 4,
  PHOTOS_SUMMARY: 5,
  [AddVehicleSteps.VIDEOS]: 6,
  [AddVehicleSteps.TYRES]: 7,
  [AddVehicleSteps.SERVICE_HISTORY]: 8,
  [AddVehicleSteps.SPECIFICATION]: 9,
  [AddVehicleSteps.DESCRIPTION]: 10,
  [AddVehicleSteps.LAUNCH_VEHICLE]: 11,
};

export const AddVehicleNavStructure = {
  VEHICLE_DETAILS_GROUP: {
    label: 'VEHICLE DETAILS',
    children: {
      [AddVehicleSteps.VEHICLE_REGISTRATION]: 'REGISTRATION NUMBER',
      [AddVehicleSteps.VEHICLE_DETAILS]: 'VEHICLE DETAILS',
      [AddVehicleSteps.SPECIFICATION]: 'SPECIFICATION',
      [AddVehicleSteps.DESCRIPTION]: 'DESCRIPTION',
    },
  },
  MEDIA_GROUP: {
    label: 'MEDIA',
    children: {
      [AddVehicleSteps.PHOTOS]: 'PHOTOS',
      [AddVehicleSteps.VIDEOS]: 'VIDEOS',
    },
  },
  CONDITION_HISTORY_GROUP: {
    label: 'CONDITION & HISTORY',
    children: {
      [AddVehicleSteps.CONDITION_INSPECTION]: 'CONDITION',
      [AddVehicleSteps.TYRES]: 'TYRES',
      [AddVehicleSteps.SERVICE_HISTORY]: 'SERVICE HISTORY',
    },
  },
  AUCTION_DETAILS_GROUP: {
    label: 'AUCTION DETAILS',
    children: {
      [AddVehicleSteps.LAUNCH_VEHICLE]: 'AUCTION DETAILS',
    },
  },
};
